import './global.css';

import faviconUrl from '#core/assets/cognite-logo-icon.svg';
import { CogniteLogo } from '#core/components/CogniteLogo.tsx';
import type { ProjectConfigInput } from '#core/schema/ProjectConfigSchema.ts';

import { theme } from './theme.ts';

export const config = {
  id: 'cognite-dashboard-aipso',
  name: 'Cognite AiPSO Dashboard',
  logo: CogniteLogo,
  faviconUrl,
  defaultColorScheme: 'dark',
  debug: { devtools: { enabled: false } },
  theme,
  feature: { ai: { enabled: true } },
} as const satisfies ProjectConfigInput;
